import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { ServiceApi } from "../services/index.service";
import {
  Alert,
  Backdrop,
  Box,
  Card,
  CardHeader,
  Switch,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { storeSet } from "../redux/store/storeSlice";
import { styled } from "@mui/material/styles";
import { HOURS_OF_OPERATION_TOUR_STEPS } from "../utils/tourConstants";
import {
  continuousTour,
  runTour,
  showTourProgress,
  updateSteps,
} from "../redux/userOnboarding/userOnboardingSlice";



const HoursOfOperation = () => {
  const dispatch = useDispatch();
  const { storage, userOnboarding } = useSelector((state) => state);
  const serviceapi = new ServiceApi();
  const { enqueueSnackbar } = useSnackbar();
  const [store, setStore] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const [dateErrors, setDateErrors] = useState("");
  const [timeErrors, setTimeErrors] = useState("");
  const [everydayError, setEverydayError] = useState("");
  const [open, setOpen] = useState(false);
  const [enableSaveTimings, setEnableSaveTimings] = useState(false);
  const [enableSaveDates, setEnableSaveDates] = useState(false);
  const [dates, setDates] = useState({
    open_date: "",
    close_date: "",
  });

  useEffect(() => {
    setDateErrors("");
    setTimeErrors("");
    setEverydayError("");
  }, []);

  React.useEffect(() => {
    setStore(storage?.store);
    setEnableSaveTimings(false);
    setEnableSaveDates(false);
  }, [storage?.store]);

  React.useEffect(() => {
    if(store?.intStoreID){
      getHoursOperationData(store?.intStoreID);
    }
  }, [store]);

  //Tour Hook
  useEffect(() => {
    if (!userOnboarding?.tourStatus?.hoursOfOperation && store) {
        startHoursOfOperationTour();
    }
  }, [store, userOnboarding?.tourStatus?.hoursOfOperation]);

  const startHoursOfOperationTour = () => {
    dispatch(updateSteps(HOURS_OF_OPERATION_TOUR_STEPS));
    dispatch(continuousTour());
    dispatch(showTourProgress());
    dispatch(runTour("hoursOfOperation"));
  };

  const getHoursOperationData = async (storeId) => {
    setDateErrors("");
    setTimeErrors("");
    setLoading(true);
    setEveryday({
      day: "everyDay",
      open_time: null,
      close_time: null,
    });
    const response = await serviceapi.getHoursOperationData({
      store_id: storeId,
    });
    if (response) {
      setDates({
        open_date: response[0].dates_data[0].dteSeasonalOpenDate,
        close_date: response[0].dates_data[0].dteSeasonalCloseDate,
      });

      if (response[0].hours_data[0].intDayNumber === 1) {
        setMonday({
          day: "Monday",
          open_time: appendTime(
            moment(response[0]?.hours_data[0]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[0]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[0].bitClosed,
          disable: response[0].hours_data[0].bitClosed,
        });
      }
      if (response[0].hours_data[1].intDayNumber === 2) {
        setTuesday({
          day: "Tuesday",
          open_time: appendTime(
            moment(response[0]?.hours_data[1]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[1]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[1].bitClosed,
          disable: response[0].hours_data[1].bitClosed,
        });
      }
      if (response[0].hours_data[2].intDayNumber === 3) {
        setWednesday({
          day: "Wednesday",
          open_time: appendTime(
            moment(response[0]?.hours_data[2]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[2]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[2].bitClosed,
          disable: response[0].hours_data[2].bitClosed,
        });
      }
      if (response[0].hours_data[3].intDayNumber === 4) {
        setThursday({
          day: "Thursday",
          open_time: appendTime(
            moment(response[0]?.hours_data[3]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[3]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[3].bitClosed,
          disable: response[0].hours_data[3].bitClosed,
        });
      }
      if (response[0].hours_data[4].intDayNumber === 5) {
        setFriday({
          day: "Friday",
          open_time: appendTime(
            moment(response[0]?.hours_data[4]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[4]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[4].bitClosed,
          disable: response[0].hours_data[4].bitClosed,
        });
      }
      if (response[0].hours_data[5].intDayNumber === 6) {
        setSaturday({
          day: "Saturday",
          open_time: appendTime(
            moment(response[0]?.hours_data[5]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[5]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[5].bitClosed,
          disable: response[0].hours_data[5].bitClosed,
        });
      }
      if (response[0].hours_data[6].intDayNumber === 7) {
        setSunday({
          day: "Sunday",
          open_time: appendTime(
            moment(response[0]?.hours_data[6]?.open_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          close_time: appendTime(
            moment(response[0]?.hours_data[6]?.close_time, ["h:mm A"]).format(
              "HH:mm"
            )
          ),
          closed_flag: response[0].hours_data[6].bitClosed,
          disable: response[0].hours_data[6].bitClosed,
        });
      }
      setLoading(false);
    }
  };
  const handleStoreChange = (event) => {
    dispatch(storeSet(event));
    getHoursOperationData(event.intStoreID);
    setStore(event);
  };
  const appendTime = (val) => {
    return dayjs(`2022-04-17T${val}`); // dayjs(`2022-04-17T${val}`);
  };
  const [everyday, setEveryday] = useState({
    day: "everyDay",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
  });

  const [monday, setMonday] = useState({
    day: "Monday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });
  const [tuesday, setTuesday] = useState({
    day: "Tuesday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });
  const [wednesday, setWednesday] = useState({
    day: "Wednesday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });
  const [thursday, setThursday] = useState({
    day: "Thursday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });
  const [friday, setFriday] = useState({
    day: "Friday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });
  const [saturday, setSaturday] = useState({
    day: "Saturday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });
  const [sunday, setSunday] = useState({
    day: "Sunday",
    open_time: appendTime("12:00"),
    close_time: appendTime("22:00"),
    closed_flag: false,
    disable: false,
  });

  const setNewOpenTime = (val, day) => {
    if (day === "mon") {
      setMonday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "tue") {
      setTuesday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "wed") {
      setWednesday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "thu") {
      setThursday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "fri") {
      setFriday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "sat") {
      setSaturday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "sun") {
      setSunday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
    } else if (day === "everyday") {
      setEveryday((prevState) => ({
        ...prevState,
        open_time: dayjs(val),
      }));
      return null;
    }
    setEnableSaveTimings(true);
  };

  const setNewCloseTime = (val, day) => {
    if (day === "mon") {
      setMonday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "tue") {
      setTuesday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "wed") {
      setWednesday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "thu") {
      setThursday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "fri") {
      setFriday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "sat") {
      setSaturday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "sun") {
      setSunday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
    } else if (day === "everyday") {
      setEveryday((prevState) => ({
        ...prevState,
        close_time: dayjs(val),
      }));
      return null;
    }
    setEnableSaveTimings(true);
  };

  const setStoreclose = (val, day) => {
    setEnableSaveTimings(true);
    if (day === "mon") {
      setMonday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    } else if (day === "tue") {
      setTuesday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    } else if (day === "wed") {
      setWednesday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    } else if (day === "thu") {
      setThursday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    } else if (day === "fri") {
      setFriday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    } else if (day === "sat") {
      setSaturday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    } else if (day === "sun") {
      setSunday((prevState) => ({
        ...prevState,
        open_time: null,
        close_time: null,
        closed_flag: val,
        disable: val,
      }));
    }
  };

  const saveOCDates = async () => {
    setDateErrors("");
    let openDt = false;
    let closeDt = false;

    if (new Date(dates?.open_date) + "" === "Invalid Date") {
      openDt = true;
    }
    if (new Date(dates?.close_date) + "" === "Invalid Date") {
      closeDt = true;
    }
    if (openDt && closeDt) {
      setDateErrors("Please enter Open and Close Dates!");
      return;
    } else if (!openDt && closeDt) {
      setDateErrors("Please enter Close Date!");
      return;
    } else if (openDt && !closeDt) {
      setDateErrors("Please enter Open Date!");
      return;
    } else {
      let cDate = "";

      setLoading(true);
      const req = {
        intStoreID: store.intStoreID,
        action: "savedates",
        data: {
          open_date: moment(new Date(dates.open_date)).format("MM/DD/YYYY"),
          close_date: moment(new Date(dates.close_date)).format("MM/DD/YYYY"),
        },
      };
      const response = await serviceapi.saveOpenCloseDates(req);
      if (response.statusCode === 201) {
        enqueueSnackbar(response.message + " ", {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        });
        setLoading(false);
      } else {
        enqueueSnackbar(response.message + " ", {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "warning",
        });
        setLoading(false);
      }
    }
  };

  const convertTime = (time) => {
    return moment(new Date(time)).format("hh:mm A");
  };

  const saveOCHours = async () => {
    setTimeErrors("");
    setEverydayError("");
    if (monday.closed_flag !== true) {
      if (
        monday.open_time === "" ||
        monday.open_time === null ||
        monday.close_time === null ||
        monday.close_time === "" ||
        new Date(monday.open_time) + "" === "Invalid Date" ||
        new Date(monday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open and Close time!");
        return;
      }
    }

    if (tuesday.closed_flag !== true) {
      if (
        tuesday.open_time === "" ||
        tuesday.open_time === null ||
        tuesday.close_time === null ||
        tuesday.close_time === "" ||
        new Date(tuesday.open_time) + "" === "Invalid Date" ||
        new Date(tuesday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open time and Close time!");
        return;
      }
    }

    if (wednesday.closed_flag !== true) {
      if (
        wednesday.open_time === "" ||
        wednesday.open_time === null ||
        wednesday.close_time === null ||
        wednesday.close_time === "" ||
        new Date(wednesday.open_time) + "" === "Invalid Date" ||
        new Date(wednesday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open time and Close time!");
        return;
      }
    }
    if (thursday.closed_flag !== true) {
      if (
        thursday.open_time === "" ||
        thursday.open_time === null ||
        thursday.close_time === null ||
        thursday.close_time === "" ||
        new Date(thursday.open_time) + "" === "Invalid Date" ||
        new Date(thursday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open time and Close time!");
        return;
      }
    }
    if (friday.closed_flag !== true) {
      if (
        friday.open_time === "" ||
        friday.open_time === null ||
        friday.close_time === null ||
        friday.close_time === "" ||
        new Date(friday.open_time) + "" === "Invalid Date" ||
        new Date(friday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open time and Close time!");
        return;
      }
    }
    if (saturday.closed_flag !== true) {
      if (
        saturday.open_time === "" ||
        saturday.open_time === null ||
        saturday.close_time === null ||
        saturday.close_time === "" ||
        new Date(saturday.open_time) + "" === "Invalid Date" ||
        new Date(saturday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open time and Close time!");
        return;
      }
    }
    if (sunday.closed_flag !== true) {
      if (
        sunday.open_time === "" ||
        sunday.open_time === null ||
        sunday.close_time === null ||
        sunday.close_time === "" ||
        new Date(sunday.open_time) + "" === "Invalid Date" ||
        new Date(sunday.close_time) + "" === "Invalid Date"
      ) {
        setTimeErrors("Please enter Open time and Close time!");
        return;
      }
    }

    setLoading(true);
    const m = JSON.parse(JSON.stringify(monday));
    if (m.closed_flag !== true) {
      m.open_time = convertTime(m.open_time);
      m.close_time = convertTime(m.close_time);
    } else {
      m.open_time = "";
      m.close_time = "";
    }
    const tu = JSON.parse(JSON.stringify(tuesday));
    if (tu.closed_flag !== true) {
      tu.open_time = convertTime(tu.open_time);
      tu.close_time = convertTime(tu.close_time);
    } else {
      tu.open_time = "";
      tu.close_time = "";
    }
    const w = JSON.parse(JSON.stringify(wednesday));
    if (w.closed_flag !== true) {
      w.open_time = convertTime(w.open_time);
      w.close_time = convertTime(w.close_time);
    } else {
      w.open_time = "";
      w.close_time = "";
    }
    const t = JSON.parse(JSON.stringify(thursday));
    if (t.closed_flag !== true) {
      t.open_time = convertTime(t.open_time);
      t.close_time = convertTime(t.close_time);
    } else {
      t.open_time = "";
      t.close_time = "";
    }
    const f = JSON.parse(JSON.stringify(friday));
    if (f.closed_flag !== true) {
      f.open_time = convertTime(f.open_time);
      f.close_time = convertTime(f.close_time);
    } else {
      f.open_time = "";
      f.close_time = "";
    }
    const sa = JSON.parse(JSON.stringify(saturday));
    if (sa.closed_flag !== true) {
      sa.open_time = convertTime(sa.open_time);
      sa.close_time = convertTime(sa.close_time);
    } else {
      sa.open_time = "";
      sa.close_time = "";
    }
    const su = JSON.parse(JSON.stringify(sunday));
    if (su.closed_flag !== true) {
      su.open_time = convertTime(su.open_time);
      su.close_time = convertTime(su.close_time);
    } else {
      su.open_time = "";
      su.close_time = "";
    }

    const payload = {
      intStoreID: store.intStoreID,
      action: "savehours",
      data: [m, tu, w, t, f, sa, su],
    };

    const response = await serviceapi.saveOpenCloseDates(payload);

    if (response.statusCode === 201) {
      setLoading(false);
      setEnableSaveTimings(false);
      enqueueSnackbar(response.message + " ", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      setLoading(false);
      enqueueSnackbar(response.message + " ", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "warning",
      });

      return;
    }
  };

  const handleReset = () => {
    setEverydayError("");
    setEnableSaveTimings(false);
    setEnableSaveDates(false);
    getHoursOperationData(store?.intStoreID);
  };

  const applyToAll = () => {
    setEverydayError("");
    if (
      everyday.open_time === "" ||
      everyday.open_time === null ||
      everyday.close_time === null ||
      everyday.close_time === "" ||
      new Date(everyday.open_time) + "" === "Invalid Date" ||
      new Date(everyday.close_time) + "" === "Invalid Date"
    ) {
      setEverydayError("Please enter default start and end time!");

      return;
    }
    let showSnackBar = false;

    if (!monday.closed_flag) {
      setNewOpenTime(everyday.open_time, "mon");
      setNewCloseTime(everyday.close_time, "mon");
      showSnackBar = true;
    }
    if (!tuesday.closed_flag) {
      setNewOpenTime(everyday.open_time, "tue");
      setNewCloseTime(everyday.close_time, "tue");
      showSnackBar = true;
    }
    if (!wednesday.closed_flag) {
      setNewOpenTime(everyday.open_time, "wed");
      setNewCloseTime(everyday.close_time, "wed");
      showSnackBar = true;
    }
    if (!thursday.closed_flag) {
      setNewOpenTime(everyday.open_time, "thu");
      setNewCloseTime(everyday.close_time, "thu");
      showSnackBar = true;
    }
    if (!friday.closed_flag) {
      setNewOpenTime(everyday.open_time, "fri");
      setNewCloseTime(everyday.close_time, "fri");
      showSnackBar = true;
    }

    if (!saturday.closed_flag) {
      setNewOpenTime(everyday.open_time, "sat");
      setNewCloseTime(everyday.close_time, "sat");
      showSnackBar = true;
    }

    if (!sunday.closed_flag) {
      setNewOpenTime(everyday.open_time, "sun");
      setNewCloseTime(everyday.close_time, "sun");
      showSnackBar = true;
    }
    setOpen(false);
    if (showSnackBar) {
      setEnableSaveTimings(true);
      // enqueueSnackbar(" Applied open and close time to all week", {
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      //   variant: "success",
      // });
    }
  };

  const handleChangeOCDates = (name, value) => {
    setEnableSaveDates(true);
    setDates((previous) => ({ ...previous, [name]: value }));
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#484848",
    // ...theme.typography.body2,
    padding: "10px",
    margin: "0px",
    textAlign: "center",
    color: "#fff",
    border: "none",
    borderRadius: "0px",
    fontWeight: 600,
    fontSize: "14px",
  }));
  const HourItem = styled(Paper)(({ theme }) => ({
    backgroundColor: "#FFF",
    // ...theme.typography.body2,
    padding: "10px",
    margin: "0px",
    textAlign: "center",
    color: "#000",
    border: "1px solid #cccccc59",
    borderRadius: "0px",
    height: "100%",
    fontWeight: 600,
    fontSize: "14px",
  }));

  const isInFutureYear = (date) => date.get("year") !== dayjs().get("year");

  return (
    <>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col">
              <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                Hours of Operation
              </h1>
              <small className="pt-2" style={{ color: "#D41D49" }}>
                <b>Note:</b> We provide updates to social partners (i.e. Google, Facebook, Yelp, etc.) within 15-20 minutes, but it may take up to 24 hours to process & display this information.
              </small>
            </div>
          </div>
        </header>
        <main>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 py-8">
          {store && (
              <div
                style={{ border: "1px solid #ccc" }}
                className="season-dates-tour-selector"
              >
                <Card>
                  <CardHeader
                    style={{
                      background: "#FFF",
                      borderRadius: "3px 3px 0px 0px",
                      border: "1px solid #ccc",
                    }}
                    subheader={
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        Season Open and Close Dates
                      </div>
                    }
                    action={
                      <div>
                        <button
                          type="button"
                          onClick={saveOCDates}
                          style={
                            enableSaveDates
                              ? { cursor: "pointer" }
                              : { cursor: "not-allowed", opacity: "0.5" }
                          }
                          className="mr-2 inline-flex items-center rounded-sm border border-[#D41042] bg-white text-[#D41042]  px-4 py-2 text-sm font-medium shadow-sm"
                        >
                          Save
                        </button>
                      </div>
                    }
                  />
                  <div>
                    {dateErrors && dateErrors !== "" && (
                      <div style={{ marginBottom: "10px" }}>
                        <Alert severity="warning">{dateErrors}</Alert>
                      </div>
                    )}
                    <Grid container>
                      <Grid item md={3}>
                        <HourItem
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography>Open Date</Typography>
                        </HourItem>
                      </Grid>
                      <Grid item md={3}>
                        <HourItem>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              shouldDisableYear={isInFutureYear}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  error: false,
                                },
                              }}
                              adapterLocale="en"
                              format="MM/DD/YYYY"
                              value={dayjs(dates.open_date)}
                              onChange={(newValue) =>
                                handleChangeOCDates("open_date", newValue)
                              }
                            />
                          </LocalizationProvider>
                        </HourItem>
                      </Grid>
                      <Grid item md={3}>
                        <HourItem
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography>Close Date</Typography>
                        </HourItem>
                      </Grid>
                      <Grid item md={3}>
                        <HourItem>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              shouldDisableYear={isInFutureYear}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  error: false,
                                },
                              }}
                              adapterLocale="en"
                              format="MM/DD/YYYY"
                              value={dayjs(dates.close_date)}
                              onChange={(newValue) =>
                                handleChangeOCDates("close_date", newValue)
                              }
                            />
                          </LocalizationProvider>
                        </HourItem>
                      </Grid>
                    </Grid>
                  </div>
                </Card>
              </div>
            )}
            {store && (
              <Card className="my-3">
                <CardHeader
                  style={{
                    background: "#FFF",
                    borderRadius: "3px 3px 0px 0px",
                    border: "1px solid #CCC;",
                  }}
                  subheader={
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#000",
                      }}
                    >
                      Shop hours of operation
                    </div>
                  }
                  action={
                    <div>
                      <button
                        type="button"
                        onClick={saveOCHours}
                        disabled={!enableSaveTimings}
                        style={
                          enableSaveTimings
                            ? { cursor: "pointer" }
                            : { cursor: "not-allowed", opacity: "0.5" }
                        }
                        className="mr-2 inline-flex items-center rounded-sm border border-[#D41042] bg-white text-[#D41042]  px-4 py-2 text-sm font-medium shadow-sm save-timings-tour-selector"
                      >
                        Save
                      </button>
                    </div>
                  }
                ></CardHeader>
                <div style={{ border: "1px solid #ccc" }}>
                  <Card>
                    {everydayError && everydayError !== "" && (
                      <div style={{ marginBottom: "10px" }}>
                        <Alert severity="warning">{everydayError}</Alert>
                      </div>
                    )}
                    <Grid
                      container
                      // spacing={4}
                      className="everyday-section-tour-selector my-3"
                    >
                      <Grid item md={2} sx={{ textAlign: "center" }}>
                        <Typography variant="body2" mt={1} component="h2">
                          Default Time
                        </Typography>
                      </Grid>
                      <Grid item md={4} sx={{ textAlign: "center" }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileTimePicker
                            slotProps={{
                              textField: {
                                size: "small",
                                error: false,
                              },
                            }}
                            label={"Start Time"}
                            value={everyday.open_time}
                            onChange={(newValue) =>
                              setNewOpenTime(newValue, "everyday")
                            }
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item md={4} sx={{ textAlign: "center" }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileTimePicker
                            slotProps={{
                              textField: {
                                size: "small",
                                error: false,
                              },
                            }}
                            label={"End Time"}
                            value={everyday.close_time}
                            onChange={(newValue) =>
                              setNewCloseTime(newValue, "everyday")
                            }
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item md={2}>
                        <Box textAlign="center">
                        <button
                            onClick={applyToAll}
                            type="button"
                            className="inline-flex items-center rounded-sm border border-[#D41042] bg-white text-[#D41042]  px-4 py-2 text-sm font-medium shadow-sm"
                          >
                            Apply to All
                          </button>
                          <button
                            onClick={handleReset}
                            type="button"
                            className="inline-flex items-center rounded-sm border border-[#ECECEC] bg-[#ECECEC] px-3 py-2 mx-2 text-sm font-medium text-[#3A3A3A] shadow-sm hover:bg-[#ECECEC]-dark2"
                          >
                            Reset
                          </button>
                    
                        </Box>
                      </Grid>
                    </Grid>
                    {/* <Collapse in={expanded} timeout="auto" unmountOnExit className="everyday-section-tour-selector">
                    </Collapse> */}
                    <div
                      style={{
                        background: "#484848",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      <Grid container>
                        <Grid item md={2}>
                          <Item>
                            <Typography>Day</Typography>
                          </Item>
                        </Grid>
                        <Grid item md={4}>
                          <Item sx={{textAlign:'left',paddingLeft:'6rem'}}>
                            <Typography>Start Time</Typography>
                          </Item>
                        </Grid>

                        <Grid item md={4}>
                        <Item sx={{textAlign:'left',paddingLeft:'6rem'}}>

                            <Typography>End Time</Typography>
                          </Item>
                        </Grid>
                        <Grid item md={2}>
                          <Item>
                            <Typography>Closed</Typography>
                          </Item>
                        </Grid>
                      </Grid>
                    </div>

                    <div className="weekly-timings-tour-selector">
                      {timeErrors && timeErrors !== "" && (
                        <div style={{ marginBottom: "10px" }}>
                          <Alert severity="warning">{timeErrors}</Alert>
                        </div>
                      )}

                      <Grid container className="hours-of-operation-grid-items">
                        <Grid item md={2}>
                          <HourItem>
                            <Typography>Monday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={monday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={monday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "mon")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={monday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={monday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "mon")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "mon");
                                setTimeErrors("");
                              }}
                              checked={monday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item md={2}>
                          <HourItem style={{ backgroundColor: "#F0F0F0" }}>
                            <Typography>Tuesday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={tuesday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={tuesday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "tue")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={tuesday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={tuesday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "tue")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "tue");
                                setTimeErrors("");
                              }}
                              checked={tuesday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item md={2}>
                          <HourItem>
                            <Typography>Wednesday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={wednesday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={wednesday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "wed")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={wednesday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={wednesday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "wed")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "wed");
                                setTimeErrors("");
                              }}
                              checked={wednesday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item md={2}>
                          <HourItem style={{ backgroundColor: "#F0F0F0" }}>
                            <Typography>Thursday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={thursday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={thursday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "thu")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={thursday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={thursday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "thu")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "thu");
                                setTimeErrors("");
                              }}
                              checked={thursday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item md={2}>
                          <HourItem>
                            <Typography>Friday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={friday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={friday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "fri")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={friday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={friday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "fri")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "fri");
                                setTimeErrors("");
                              }}
                              checked={friday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item md={2}>
                          <HourItem style={{ backgroundColor: "#F0F0F0" }}>
                            <Typography>Saturday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={saturday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={saturday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "sat")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={saturday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={saturday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "sat")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "sat");
                                setTimeErrors("");
                              }}
                              checked={saturday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item md={2}>
                          <HourItem>
                            <Typography>Sunday</Typography>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={sunday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={sunday.open_time}
                                onChange={(newValue) =>
                                  setNewOpenTime(newValue, "sun")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={4}>
                          <HourItem>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <MobileTimePicker
                                disabled={sunday.disable}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                                value={sunday.close_time}
                                onChange={(newValue) =>
                                  setNewCloseTime(newValue, "sun")
                                }
                              />
                            </LocalizationProvider>
                          </HourItem>
                        </Grid>
                        <Grid item md={2}>
                          <HourItem>
                            <Switch
                              onChange={(e) => {
                                setStoreclose(e.target.checked, "sun");
                                setTimeErrors("");
                              }}
                              checked={sunday.closed_flag}
                            />
                          </HourItem>
                        </Grid>
                      </Grid>
                    </div>
                    {/* <CardActions>
                      <div className="m-2" style={{ marginLeft: "auto" }}>
                        <button
                          style={{ marginLeft: "auto" }}
                          type="button"
                          onClick={saveOCHours}
                          className="mr-12 inline-flex items-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 save-timings-tour-selector"
                        >
                          SAVE
                        </button>
                      </div>
                    </CardActions> */}
                  </Card>
                </div>
              </Card>
            )}
           
            {!store && (
              <div
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  margin: "10px",
                  backgroundColor: "#FFF",
                  color: "#000",
                }}
              >
                Please select a store!
              </div>
            )}
          </div>
        </main>
      </div>
    </>
  );
};

export default HoursOfOperation;
